export function isCourseEditingOverrideEnabled(state, now = Date.now()) {
    return (
        state?.can_enable === true &&
        state.enabled === true &&
        (state.expires_at === null ||
            (Number.isFinite(Date.parse(state.expires_at)) && Date.parse(state.expires_at) > now))
    );
}
